const CONTROL_KEY = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9] as const

export function isValidCNP(cnp: string): boolean {
  if (!/^\d{13}$/.test(cnp)) return false

  const digits = cnp.split('').map((d) => parseInt(d, 10))
  const s = digits[0]
  const yy = digits[1] * 10 + digits[2]
  const mm = digits[3] * 10 + digits[4]
  const dd = digits[5] * 10 + digits[6]

  let year: number
  switch (s) {
    case 1:
    case 2:
      year = 1900 + yy
      break
    case 3:
    case 4:
      year = 1800 + yy
      break
    case 5:
    case 6:
      year = 2000 + yy
      break
    case 7:
    case 8:
    case 9: {
      const currentYy = new Date().getFullYear() % 100
      year = 2000 + yy
      if (yy > currentYy) year -= 100
      break
    }
    default:
      return false
  }

  if (year < 1800 || year > 2099) return false

  const date = new Date(Date.UTC(year, mm - 1, dd))
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== mm - 1 ||
    date.getUTCDate() !== dd
  ) {
    return false
  }

  let sum = 0
  for (let i = 0; i < 12; i++) sum += digits[i] * CONTROL_KEY[i]
  const remainder = sum % 11
  const expected = remainder === 10 ? 1 : remainder
  return expected === digits[12]
}
